export const caseHistoryKey = [
  { label: 'Case ID', varName: 'CRID' },
  { label: 'Open Date', varName: 'StatusDate', valueMask: 'date' },
  { label: 'Status', varName: 'StatusName' },
];
export const sideKey = { B: 'Buy', S: 'Sell' };
export const statusKey = {
  PEN: 'Pending',
  APP: 'Approved',
  SYS: 'System Approved',
  BLK: 'Bulk Approved',
  INP: 'In Process',
  REJ: 'Rejected',
  REO: 'Reopened',
  REV: 'Reviewed',
  tst: 'Test',
};
export const scoreClassKey = {
  Positive: 'check_circle',
  positive: 'check_circle',
  Warning: 'error',
  warning: 'error',
  Negative: 'remove_circle',
  negative: 'remove_circle',
  Neutral: 'pending',
  neutral: 'pending',
};
export const yesNoKey = {
  Y: 'Yes',
  N: 'No',
};
export const entityKey = {
  P: 'Person',
  E: 'Entity',
  O: 'Trust',
};
export const productTypeKey = {
  CA: 'Cash',
  EQ: 'Equity',
  EP: 'Preferred',
  FI: 'Fixed Income',
  MF: 'Mutual Fund',
  OP: 'Option',
  UT: 'UIT',
  ET: 'ETF',
  DB: 'Debt',
  FT: 'Future',
  RT: 'REIT',
  CC: 'Currency',
  LP: 'Limited Partnership',
  CM: 'Commodity',
  WA: 'Warrant',
  CD: 'CD',
  T: 'Term',
  WL: 'Whole Life',
  UL: 'UL',
  IUL: 'Indexed UL',
  VUL: 'Variable UL',
  JUL: 'Joint UL',
  SUL: 'Survivorship UL',
  GT: 'Group Insurance - Term',
  VA: 'Variable Annuity',
  IA: 'Fixed Indexed Annuity',
  VIA: 'RILA',
  FA2: 'Fixed Annuity',
  SPIA: 'SPIA',
  DIA: 'Deferred Income Annuity',
  OTH: 'Other',
  NA: 'Undefined',
};
